/* eslint-disable */
import { BsCodeSlash } from "react-icons/bs";
import { FaNetworkWired, FaShieldAlt, FaServer } from "react-icons/fa";
import { MdSchool } from "react-icons/md";

export const servicesData = [
    {
        id: 1,
        title: 'DSI externe & pilotage informatique',
        icon: <FaNetworkWired size={48}/>
    },
    {
        id: 2,
        title: 'Audit sécurité & infrastructure',
        icon: <FaShieldAlt size={48}/>
    },
    {
        id: 3,
        title: 'Formation professionnelle',
        icon: <MdSchool size={48} />
    },
    {
        id: 4,
        title: 'Développement d\'outils métier',
        icon: <BsCodeSlash size={48} />
    },
    {
        id: 5,
        title: 'Hébergement et maintenance',
        icon: <FaServer size={48} />
    },
]